import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useState } from "react";

import Accordion from "../../../../../ui library/components/accordions/Accordion";

import KPIAccordionDetails from "./KPIAccordionDetails";
import KPIAccordionSummary from "./KPIAccordionSummary";

const Metrics = ({ data }) => {
  const [expandedAccordions, setExpandedAccordions] = useState([0]);
  const icons = {
    expandIcon: <KeyboardArrowDown className="mx-2 text-3xl text-blue-700" />,
    shrinkIcon: <KeyboardArrowUp className="mx-2 text-3xl text-blue-700" />,
  };

  return (
    <div className="h-[45%] w-full rounded-[15px] bg-white p-2 shadow-md">
      <Accordion
        accordionItem={{
          summaryClasses: "bg-white w-full py-2",
          expandedAccordions,
          setExpandedAccordions,
          data: data,
        }}
        icons={icons}
        summaryContent={KPIAccordionSummary}
        expandedContent={<KPIAccordionDetails />}
        index={0}
        expandOnIconClickOnly={false}
        totalExpandedAccordions={{
          expandedAccordions,
          setExpandedAccordions,
        }}
      />
    </div>
  );
};

export default Metrics;
